import React from 'react';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { FieldError } from '../../../components/form-page-parts';

export interface LookupOption {
    value: string | number;
    label: string;
}

// Tabelas do PNCP (id/nome) como opções "id - nome"
export function toLookupOptions(items: { id: string | number; name: string }[], showId = true): LookupOption[] {
    return items.map((item) => ({ value: Number(item.id), label: showId ? `${item.id} - ${item.name}` : item.name }));
}

// Select com rótulo acima e mensagem de erro abaixo; opção vazia opcional ("Selecionar"/"Todos")
export function LookupSelect({ label, name, value, options, onChange, required, error, emptyLabel, disabled }: {
    label: string;
    name: string;
    value?: string | number | null;
    options: LookupOption[];
    onChange: (e: any) => void;
    required?: boolean;
    error?: string | false;
    emptyLabel?: string;
    disabled?: boolean;
}) {
    return (
        <React.Fragment>
            <InputLabel required={required}>{label}</InputLabel>
            <Select fullWidth name={name} value={value === undefined || value === null || value === 0 ? '' : value} onChange={onChange} error={!!error} disabled={disabled}>
                {emptyLabel && <MenuItem value=""><em>{emptyLabel}</em></MenuItem>}
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
            </Select>
            <FieldError message={error} />
        </React.Fragment>
    );
}
